import React from 'react';
import { Alert } from 'antd';
import { useLocalStorageState } from 'ahooks';
import styled from 'types/theme.types';
import { FormattedMessage } from 'react-intl';

const CURRENT_BANNER_ID = 'ez-masterclass-april-2026';

const BANNER_LINK =
  'https://pages.env0.com/ez-masterclass?utm_campaign=41775973-env_zero_masterclass_series_2026&utm_source=product';

const AnnouncementBanner: React.FC = () => {
  const [dismissed, setDismissed] = useLocalStorageState<boolean>(
    `announcement-banner-dismissed-${CURRENT_BANNER_ID}`,
    {
      defaultValue: false
    }
  );

  if (dismissed) {
    return null;
  }

  return (
    <BannerContainer>
      <Alert
        data-e2e="announcement-banner"
        type="info"
        showIcon={false}
        closable
        onClose={() => setDismissed(true)}
        message={
          <BannerContent>
            <span>
              <FormattedMessage id="announcement.banner.message" />
            </span>
            <BannerLink href={BANNER_LINK} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="announcement.banner.cta" />
            </BannerLink>
          </BannerContent>
        }
      />
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  .ant-alert {
    border-radius: 0;
    border: none;
    padding: 6px 20px;
    background-color: #c8ee44;
  }

  .ant-alert-message {
    color: #1a1a1a;
    font-size: 14px;
  }

  .ant-alert-close-icon {
    color: #1a1a1a;

    &:hover {
      color: rgba(26, 26, 26, 0.6);
    }
  }
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const BannerLink = styled.a`
  color: #1a1a1a;
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    color: rgba(26, 26, 26, 0.7);
  }
`;

export default AnnouncementBanner;
